const sharingTokenElmt = document.getElementById('sharingToken')
export default () => sharingTokenElmt && sharingTokenElmt.value
